import N8nBlockUi from './BlockUi.vue';

export default N8nBlockUi;
